import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { get } from '@/api/produit/produitAutre';
import { get as getProduitAssocie } from '@/api/produit/index';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import {
  CATEGORIE_AUTRE,
} from '@/configuration/catalogue/produitConf';
import { REGROUPEMENT } from '@/configuration/devisConf';
import setFournisseurIfNotRegie
  from '@/services/devisCommandes/bonAFacturer/setFournisseurIfNotRegie';
import setAFacturerOfLigne from '@/services/devisCommandes/bonAFacturer/setAFacturerOfLigne';
import getAllLiaisonTarifById from '@/services/catalogue/getAllLiaisonTarifById';
import generationToutesLignesCommandesByPrestation from '@/services/devisCommandes/ajoutProduit/genererToutesLignesCommandeByPrestation';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

function generationLigneCommandeRegroupement(
  produitAutre, produitsAssocies, presation, dcf, tauxTva,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande);
  nouvelleLigneCommande.title = produitAutre.reference + ' - ' + produitAutre.libelle;
  nouvelleLigneCommande.produitId = produitAutre.id;
  nouvelleLigneCommande.typeProduit = CATEGORIE_AUTRE;
  nouvelleLigneCommande.produit = produitAutre;
  nouvelleLigneCommande.tauxTva = 0;
  nouvelleLigneCommande.dateDebut = new Date();
  nouvelleLigneCommande.dateFin = new Date();
  nouvelleLigneCommande.libelle = produitAutre.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = REGROUPEMENT;

  nouvelleLigneCommande.lignesCommande = [];

  if (presation) {
    nouvelleLigneCommande.lignesCommande = nouvelleLigneCommande.lignesCommande
      .concat(generationToutesLignesCommandesByPrestation(presation));
  }

  if (produitsAssocies) {
    produitsAssocies.forEach((el) => {
      const ligne = generationToutesLignesCommandes(el, tauxTva);
      nouvelleLigneCommande.lignesCommande.push(ligne[0]);
    });
  }

  // AJOUT D INFORMATION SUPPLEMENTAIRE EN FONCTION DE LA SOCIETE (REGIE, MANDATIARE ...)
  setFournisseurIfNotRegie(produitAutre, nouvelleLigneCommande);
  setAFacturerOfLigne(nouvelleLigneCommande, dcf);

  return nouvelleLigneCommande;
}

export async function ajoutLignesCommandeProduitAutre(
  devisCommande, idProduit, idProduitAssocie, ordre, tauxTva,
) {
  const produitAutre = (await get(idProduit)).data.result;
  let liaisonTarif = null;
  if (idProduitAssocie !== null && produitAutre.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitAutre, idProduitAssocie, new Date());
  }
  if (!liaisonTarif) {
    const produitAssocie = (await getProduitAssocie(idProduitAssocie))
      .data.result;
    liaisonTarif = genererLiaisonTarifFromProduitAssocie(
      produitAssocie,
    );
  }
  const liaisonToSend = [];
  let nouvelleLignesCommande = null;
  if (!Array.isArray(liaisonTarif)) liaisonToSend.push(liaisonTarif);

  if (liaisonToSend.length === 1) {
    const presation = produitAutre.produitAutre.prestations
      .find((presation) => presation.id === liaisonToSend[0].produitEnfantId);
    nouvelleLignesCommande = generationLigneCommandeRegroupement(
      produitAutre, [], presation, devisCommande, tauxTva,
    );
  } else {
    nouvelleLignesCommande = generationLigneCommandeRegroupement(
      produitAutre, liaisonToSend, null, devisCommande, tauxTva,
    );
  }
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  genererCommentaireVenteForLigne(produitAutre, nouvelleLignesCommande);
  return [nouvelleLignesCommande];
}

export async function ajoutLignesCommandeProduitAutreFromPlanningAutre(
  produitAutreId, liaisonsId,
) {
  const produitAutre = (await get(produitAutreId)).data.result;
  let prestation = null;
  if (produitAutre?.produitAutre?.prestations?.length > 0) {
    const prestationsFilter = produitAutre.produitAutre.prestations
      .filter(p => liaisonsId.includes(p.id));
    if (prestationsFilter.length > 0) prestation = prestationsFilter[0];
  }
  let liaisonTarif = null;
  if (produitAutre.liaisonsTarif.length > 0) {
    liaisonTarif = getAllLiaisonTarifById(produitAutre, liaisonsId);
  }
  const ligne = generationLigneCommandeRegroupement(
    produitAutre, liaisonTarif, prestation,
  );
  genererCommentaireVenteForLigne(produitAutre, ligne);
  ligne.isFromDCF = false;
  return ligne;
}
